// extracted by mini-css-extract-plugin
module.exports = {"detailContainer":"Detail_detailContainer__1ZYPz","detailImage":"Detail_detailImage__1aShE"};